import { render } from "./CardDokterAppointment.vue?vue&type=template&id=3a3f71a2&scoped=true"
import script from "./CardDokterAppointment.vue?vue&type=script&lang=js"
export * from "./CardDokterAppointment.vue?vue&type=script&lang=js"

import "./CardDokterAppointment.vue?vue&type=style&index=0&id=3a3f71a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3f71a2"]])

export default __exports__